import React, { useState, useRef, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
//import SearchBar from "./SearchBar";
import Notificaciones from "./Notificaciones";
import Sidebar from "./Sidebar";
import { updateProfile } from "firebase/auth";
import FullScreen from "./FullScreen";
import { useAuth } from "../context/AuthContext";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { storage } from "../firebaseConfig";
import { useNavContext } from "../context/NavContext"; // Importar el hook del contexto

const resizeImage = (file) => {
  // Tu función de redimensionamiento permanece igual
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (event) => {
      const img = new Image();
      img.src = event.target.result;

      img.onload = () => {
        const canvas = document.createElement("canvas");
        const maxWidth = 800;
        const maxHeight = 800;

        let width = img.width;
        let height = img.height;

        if (width > height) {
          if (width > maxWidth) {
            height *= maxWidth / width;
            width = maxWidth;
          }
        } else {
          if (height > maxHeight) {
            width *= maxHeight / height;
            height = maxHeight;
          }
        }

        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, width, height);

        canvas.toBlob(
          (blob) => {
            if (blob) {
              resolve(blob);
            } else {
              reject(new Error("Error al redimensionar la imagen"));
            }
          },
          "image/jpeg",
          0.7
        );
      };

      img.onerror = () => {
        reject(new Error("Error al cargar la imagen"));
      };
    };
    reader.onerror = (error) => reject(error);
  });
};

const Nav = () => {
  // agrega setSearchTerm aqui abajo por si quieres utilizar el SearchBar
  const { proximasAVencer, proximosEventos } = useNavContext(); // Consumir el contexto

  const {
    user,
    logout,
    userRole,
    avatarUrl,
    firstName,
    lastName,
    setAvatarUrl,
  } = useAuth();

  const [menuVisible, setMenuVisible] = useState(false);
  const [cropModalOpen, setCropModalOpen] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [crop, setCrop] = useState({ x: 50, y: 50, width: 300, height: 300 });
  const [uploading, setUploading] = useState(false);
  const cropBoxRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const handleSidebarToggle = (isOpen) => {
    setIsSidebarOpen(isOpen); // Actualiza el estado del Sidebar en Nav
  };

  // Función para alternar el estado del sidebar
  const toggleSidebar = () => {
    setIsSidebarOpen((prev) => !prev);
  };

  useEffect(() => {
    const sidebarButton = document.querySelector(".menu-toggle-btn");
    if (sidebarButton) {
      sidebarButton.addEventListener("click", toggleSidebar);
    }

    return () => {
      if (sidebarButton) {
        sidebarButton.removeEventListener("click", toggleSidebar);
      }
    };
  }, []);

  const handleClick = () => {
    setMenuVisible(!menuVisible);
  };

  const handleLogout = async () => {
    await logout();
    navigate("/login");
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (!file.type.startsWith("image/")) {
      Swal.fire({
        icon: "error",
        title: "Archivo no válido",
        text: "Por favor, selecciona un archivo de imagen.",
        confirmButtonColor: "#007bff",
      });
      return;
    }

    setSelectedFile(file);
    setCropModalOpen(true);
  };

  const handleCropMouseDown = (e) => {
    e.preventDefault();
    const startX = e.clientX;
    const startY = e.clientY;
    const initialCrop = { ...crop };

    const handleMouseMove = (moveEvent) => {
      const diffX = moveEvent.clientX - startX;
      const diffY = moveEvent.clientY - startY;

      setCrop((prevCrop) => ({
        ...prevCrop,
        x: Math.max(0, Math.min(initialCrop.x + diffX, 800 - prevCrop.width)),
        y: Math.max(0, Math.min(initialCrop.y + diffY, 800 - prevCrop.height)),
      }));
    };

    const handleMouseUp = () => {
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mouseup", handleMouseUp);
    };

    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseup", handleMouseUp);
  };

  const handleConfirmImage = async () => {
    if (!selectedFile) return;

    setUploading(true);

    try {
      const resizedFile = await resizeImage(selectedFile);
      const storageRef = ref(
        storage,
        `avatars/${user.uid}/${selectedFile.name}`
      );

      const uploadTask = uploadBytesResumable(storageRef, resizedFile);

      uploadTask.on(
        "state_changed",
        null,
        (error) => {
          console.error("Error al subir la imagen:", error);
          setUploading(false);
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "Hubo un problema al subir la imagen. Por favor, intenta nuevamente.",
            confirmButtonColor: "#007bff",
          });
        },
        async () => {
          const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
          // Actualizar avatar en AuthContext y Firestore
          await updateProfile(user, { photoURL: downloadURL });
          await setAvatarUrl(downloadURL); // Llama a setAvatarUrl desde el contexto

          setCropModalOpen(false);
          setUploading(false);

          Swal.fire({
            icon: "success",
            title: "Imagen subida correctamente",
            text: "Tu imagen se ha subido y guardado exitosamente",
            confirmButtonColor: "#007bff",
          });
        }
      );
    } catch (error) {
      console.error("Error al procesar la imagen:", error);
      setUploading(false);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Hubo un problema al procesar la imagen. Por favor, intenta nuevamente.",
        confirmButtonColor: "#007bff",
      });
    }
  };

  const routeStyleMap = {
    "/orden": {
      open: "-200px",
      closed: "-560px",
    },
    "/articulos-venta": {
      open: "-200px",
      closed: "-560px",
    },
    "/articulos-compra": {
      open: "-200px",
      closed: "-560px",
    },
    "/proveedores": {
      open: "-200px",
      closed: "-560px",
    },
    "/plantillas": {
      open: "-200px",
      closed: "-560px",
    },
    "/usuarios": {
      open: "-280px",
      closed: "-660px",
    },
    "/facturas-de-proveedores": {
      open: "-150px",
      closed: "-530px",
    },
    "/facturas-de-clientes": {
      open: "-200px",
      closed: "-560px",
    },
    "/calculador": {
      open: "-200px",
      closed: "-580px",
    },
    "/grupos": {
      open: "-350px",
      closed: "-700px",
    },
    "/generador": {
      open: "-260px",
      closed: "-640px",
    },
    "/tareas": {
      open: "-380px",
      closed: "-650px"
    },
    "/orden-de-compra": {
      open: "-250px",
      closed: "-580px"
    }
    // Agrega aquí las rutas que necesites con sus valores
  };

  const pageTitles = {
    "/inicio": "Inicio / Dashboard",
    "/tareas": "Tareas / Tareas",
    "/calendario": "Calendario / Calendario",
    "/cotizacion": "Clientes / Cotizaciones",
    "/orden-de-compra": "Clientes / Ordenes de Compra",
    "/remisiones": "Clientes / Remisiones",
    "/orden": "Proveedores / Órdenes de Compra",
    "/articulos-venta": "Inventario / Artículos de venta",
    "/articulos-compra": "Inventario / Artículos de compra",
    "/categorias": "Inventario / Categorías",
    "/todos": "Contactos / Todos",
    "/clientes": "Contactos / Clientes",
    "/proveedores": "Contactos / Proveedores",
    "/usuarios": "Configuración / Usuarios",
    "/plantillas": "Configuración / Plantillas",
    "/facturas-de-proveedores": "Proveedores / Facturas de Proveedores",
    "/facturas-de-clientes": "Clientes / Facturas de Clientes",
    "/calculador": "Clientes / Calculador de Costos",
    "/grupos": "Inventario / Grupos",
    "/generador": "Reportes / Generador de Obra",
  };

  function getTitleMargin(pathname, isSidebarOpen, currentTitle) {
    // 1) Detectar ruta dinámica de CATEGORÍAS
    const isProductosRelacionados = /^\/categorias\/[^/]+\/productos$/.test(
      pathname
    );
    if (isProductosRelacionados) {
      if (currentTitle.length > 42) {
        return isSidebarOpen ? "-110px" : "-450px";
      } else {
        return isSidebarOpen ? "-200px" : "-600px";
      }
    }

    // 2) Detectar ruta dinámica de GRUPOS
    const isProductosGrupos = /^\/grupos\/[^/]+\/productos$/.test(pathname);
    if (isProductosGrupos) {
      // Aplica márgenes similares o personaliza
      if (currentTitle.length > 42) {
        return isSidebarOpen ? "-110px" : "-450px";
      } else {
        return isSidebarOpen ? "-280px" : "-680px";
      }
    }

    // 3) Si la ruta está en el mapa estático, usa esos estilos
    if (routeStyleMap[pathname]) {
      return isSidebarOpen
        ? routeStyleMap[pathname].open
        : routeStyleMap[pathname].closed;
    }

    // 4) Valor por defecto
    return isSidebarOpen ? "-300px" : "-700px";
  }

  const getTitle = () => {
    const pathname = location.pathname;

    // 1) Ruta dinámica para CATEGORÍAS
    const categoriasProductosRegex = /^\/categorias\/([^/]+)\/productos$/;
    const matchCategorias = pathname.match(categoriasProductosRegex);
    if (matchCategorias) {
      const categoriaNombre = decodeURIComponent(matchCategorias[1]); // Decodificar
      return `Categorías / ${categoriaNombre}`;
    }

    // 2) Ruta dinámica para GRUPOS
    const gruposProductosRegex = /^\/grupos\/([^/]+)\/productos$/;
    const matchGrupos = pathname.match(gruposProductosRegex);
    if (matchGrupos) {
      const grupoNombre = decodeURIComponent(matchGrupos[1]); // Decodificar
      return `Grupos / ${grupoNombre}`;
    }

    // 3) Si no coincide con ninguna de las rutas dinámicas
    return pageTitles[pathname] || "Inicio / Dashboard";
  };

  const currentTitle = getTitle();
  // Dividimos en main y secondary
  const [mainText, secondaryText] = currentTitle.split(" / ");

  // Usamos nuestra función refactorizada para obtener el marginLeft
  const marginLeftValue = getTitleMargin(
    location.pathname,
    isSidebarOpen,
    currentTitle
  );

  return (
    <div
      style={{
        position: "sticky",
        top: 0,
        padding: "5px",
        zIndex: 100,
        boxShadow: "0 1px 5px rgba(0,0,0,0.1)",
        backgroundColor: "#FFF",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "5px 0",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", flex: 1 }}>
          <Sidebar onToggleSidebar={handleSidebarToggle} />{" "}
          {/* Aquí pasamos handleSidebarToggle al Sidebar */}
          <div
            style={{
              marginLeft: marginLeftValue, // <-- AHORA aplicamos la función
              textAlign: "center",
              flex: 1,
              transition: "margin-left 0.3s ease-in-out", // Transición suave
            }}
          >
            <h3
              style={{
                margin: 0,
                fontFamily: "Montserrat, sans-serif",
                letterSpacing: "0.5px",
              }}
            >
              <span style={{ color: "#888" }}>{mainText}</span>
              {secondaryText && (
                <span style={{ fontWeight: "bold", color: "#333" }}>
                  {" "}
                  / {secondaryText}
                </span>
              )}
            </h3>
          </div>
        </div>

        <div
          style={{
            position: "absolute",
            left: "62%",
            top: "50%",
            transform: "translate(-58%, -50%)",
            width: "15%",
            minWidth: "320px",
          }}
        >
          {/*<div className="search-input-wrapper">
            <SearchBar handleSearch={setSearchTerm} />
          </div>*/}
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "20px",
            marginRight: "20px",
          }}
        >
          <Notificaciones
            proximasAVencer={proximasAVencer}
            proximosEventos={proximosEventos}
          />
          <div className="moon-icon-container">
            <i
              className="bi bi-moon"
              style={{ cursor: "pointer", fontSize: "1.5rem" }}
            ></i>
          </div>
          <FullScreen />
          <div style={{ position: "relative" }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                backgroundColor: "#f7f9f9",
                width: "200px",
                padding: "5px",
                borderRadius: "5px",
              }}
            >
              <label htmlFor="avatarUpload" style={{ cursor: "pointer" }}>
                {avatarUrl ? (
                  <img
                    src={avatarUrl}
                    alt="Avatar"
                    style={{
                      width: "45px",
                      height: "45px",
                      borderRadius: "50%",
                    }}
                  />
                ) : (
                  <img
                    src="/img/avatar2.jpg"
                    alt="Avatar por defecto"
                    style={{
                      width: "45px",
                      height: "45px",
                      borderRadius: "50%",
                    }}
                  />
                )}
              </label>
              <input
                id="avatarUpload"
                type="file"
                accept="image/png, image/jpeg, image/jpg"
                style={{ display: "none" }}
                onChange={handleImageUpload}
              />
              <div style={{ margin: "0 auto" }}>
                <div
                  style={{
                    fontWeight: "bold",
                    fontSize: "14px",
                    textAlign: "center",
                  }}
                >
                  {firstName} {lastName}
                </div>
                <div
                  style={{
                    fontWeight: "normal",
                    fontSize: "14px",
                    textAlign: "center",
                  }}
                >
                  {userRole}
                </div>
              </div>
              <i
                className="bi bi-chevron-down"
                onClick={handleClick}
                style={{ fontSize: "1rem", cursor: "pointer" }}
              ></i>
            </div>
            {menuVisible && (
              <div
                style={{
                  position: "absolute",
                  top: "60px",
                  right: "0",
                  backgroundColor: "#fff",
                  borderRadius: "5px",
                  zIndex: 1000,
                }}
              >
                <div
                  onClick={handleLogout}
                  className="logout-container"
                  style={{
                    padding: "10px 20px",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <span className="logout-icon" style={{ marginRight: "10px" }}>
                    <i className="bi bi-box-arrow-right"></i>
                  </span>
                  <span className="logout-text">Cerrar sesión</span>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {cropModalOpen && (
        <div
          className="crop-container"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
          }}
        >
          <div
            className="crop-modal"
            style={{
              backgroundColor: "#fff",
              padding: "20px",
              borderRadius: "10px",
              position: "relative",
              width: "400px",
              maxWidth: "90%",
            }}
          >
            <div
              style={{ position: "relative", width: "100%", height: "auto" }}
            >
              <img
                src={selectedFile ? URL.createObjectURL(selectedFile) : ""}
                alt="Cropped Preview"
                style={{
                  width: "100%",
                  borderRadius: "10px",
                  userSelect: "none",
                }}
              />
              <div
                ref={cropBoxRef}
                style={{
                  position: "absolute",
                  border: "2px solid blue",
                  width: `${crop.width}px`,
                  height: `${crop.height}px`,
                  left: `${crop.x}px`,
                  top: `${crop.y}px`,
                  cursor: "move",
                }}
                onMouseDown={handleCropMouseDown}
              ></div>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "10px",
              }}
            >
              <button
                onClick={() => setCropModalOpen(false)}
                style={{
                  padding: "10px 20px",
                  backgroundColor: "#6c757d",
                  border: "none",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
              >
                Cancelar
              </button>
              <button
                onClick={handleConfirmImage}
                disabled={uploading}
                style={{
                  padding: "10px 20px",
                  backgroundColor: uploading ? "#999" : "#007bff",
                  color: "#fff",
                  border: "none",
                  borderRadius: "5px",
                  cursor: uploading ? "not-allowed" : "pointer",
                }}
              >
                {uploading ? "Subiendo..." : "OK"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Nav;
